export const monthNames = [
  '1月',
  '2月',
  '3月',
  '4月',
  '5月',
  '6月',
  '7月',
  '8月',
  '9月',
  '10月',
  '11月',
  '12月',
];
// 年度下拉選單的共用資料來源：回傳 startYear 到「今年 + 1」的年份字串陣列
export function getYearNames(startYear = 2015) {
  const endYear = new Date().getFullYear() + 1;
  const result = [];
  for (let y = startYear; y <= endYear; y += 1) {
    result.push(`${y}`);
  }
  return result;
}
export const yearNames = getYearNames();
const nowYear = new Date().getFullYear();
const tempYears = [];

for (let index = 0; index < nowYear - 2017; index += 1) {
  tempYears.push({ id: `${2018 + index}`, text: `西元${2018 + index}` });
}

export function CalculateNormalHourMultipiler(hour){
  if(hour <= 2)
    return hour * 1.34
  if(hour <= 8)
    return (2 * 1.34) + ((hour - 2) * 1.67);
  if(hour > 8)
    return (2 * 1.34) + (6 * 1.67) + ((hour - 8) * 2);


  return (2 * 1.34) + ((hour - 6) * 1.67) + ((hour - 8) * 2);
}
export function CalculateHolidayHourMultipiler(hour){
  if(hour <= 2)
    return hour * 1.34
  if(hour <= 8)
    return (2 * 1.34) + ((hour - 2) * 1.67);
  if(hour > 8)
    return (2 * 1.34) + (6 * 1.67) + ((hour - 8) * 2.67);

  return -1;
}
export function GetStoreRole(storeId){
  if(storeId === '1') 
   return localStorage.getItem('role1') 
  if(storeId === '2') 
   return localStorage.getItem('role2')
  if(storeId === '3') 
  return localStorage.getItem('role3')

}

export function GetStoreDetailRole(storeId){
  if(storeId === '1') 
   return localStorage.getItem('detailroleId1') 
  if(storeId === '2') 
   return localStorage.getItem('detailroleId2')
  if(storeId === '3') 
  return localStorage.getItem('detailroleId3')

}
export const years = tempYears;
//7:內場兼職工讀生,10:吧檯兼職工讀生,14:外場兼職工讀生,21:內場兼職廚助,22:兼職輔導管理者,23:兼職輔導老師
export const partTimeJobIds = [ 7,10,14,21,22,23 ];

export const eventTypes = [
  {
    id: 3,
    title: '包場',
  }, {
    id: 4,
    title: '課程',
  }, {
    id: 5,
    title: '活動',
  },
];

export const typesJobs = [
  {
    id: 1,
    title: '預期上班人數',
    eventColor: 'skyblue',
  }, {
    id: 3,
    title: '包場',
    eventColor: '#918682',
  }, {
    id: 4,
    title: '課程',
    eventColor: '#918682',
  }, {
    id: 5,
    title: '活動',
    eventColor: '#918682',
  }, {
    id: 6,
    title: '調完班後的上班人數',
    eventColor: 'skyblue',
  }, {
    id: 8,
    title: '例假',
    eventColor: 'FireBrick',
  }, {
    id: 9,
    title: '休假',
    eventColor: 'Gold',
  }, {
    id: 10,
    title: '國定假日排假',
    eventColor: 'IndianRed',
  }, {
    id: 11,
    title: '國定假日',
    eventColor: '#71C171',
  }, {
    id: 12,
    title: '當日營收',
    eventColor: '#347ED2',
  },
];
